// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pinsir_mega: PokeData = {
  "id": 10040,
  "name": "pinsir-mega",
  "height": 17,
  "weight": 590,
  "base_experience": 210,
  "types": [
    PokeType.BUG,
    PokeType.FLYING
  ],
  "api_moves": [
    "vice-grip",
    "guillotine",
    "swords-dance",
    "bind",
    "thrash",
    "submission",
    "seismic-toss",
    "harden",
    "focus-energy",
    "vital-throw",
    "superpower",
    "revenge",
    "brick-break",
    "x-scissor",
    "double-hit",
    "storm-throw"
  ],
  "moves": [
    "seismic-toss",
    "superpower",
    "gust",
    "sky-attack",
    "air-slash",
    "tailwind",
    "string-shot",
    "hurricane",
    "acrobatics",
    "roost",
    "aerial-ace",
    "sticky-web",
    "pounce"
  ],
  "evolution_chain": {
    "id": 62,
    "item": null,
    "species": [
      {
        "name": "pinsir",
        "order": 151,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 99,
    "speed": 122,
    "ability_power": 180
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
